import {
  formatDate,
  formatDateNice,
} from './format-date/index.js'

import { concat } from './concat/index.js'
import { formatUcfirst } from './format-ucfirst/index.js'
import { formatCustomerName } from './format-customer-name/index.js'
import { formatServicePrice } from './format-service-price/index.js'
import { formatCurrency } from './format-currency/index.js'
import { formatPrecision } from './format-precision/index.js'

import { formatSubscriptionCurrency } from './format-subscription-currency/index.js'

import { formatRelativeDelta } from './format-relative-delta/index.js'

export function useFilters () {
  return {
    formatDate,
    formatDateNice,
    concat,
    formatCustomerName,
    formatServicePrice,
    formatCurrency,
    formatUcfirst,
    formatRelativeDelta,
    formatSubscriptionCurrency,
    formatPrecision,
  }
}
